module.exports = __webpack_public_path__ + "img/wode1301.503188d9.png";